import createModule from "../createModule"
import view from "./view"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getDatasets, getEntitlements, getTeamId, getTeamRole, getTabs } from "./selectors"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    teamAlias: props.params.teamAlias,
    role: getRole(state),
  }),
  required: ["account", "teamAlias"],
  data: [{
    resource: "teamDatasetEntitlements",
    passthrough: true,
    url: ({ teamAlias }) => {
      return {
        id: `team-dataset-entitlements-${teamAlias}`,
        query: `query ($teamAlias: IdOrAlias!) {
          team (id: $teamAlias) {
            id
            name
            alias
            role
            datasetEntitlements {
              id
              name
            }
          }
        }`,
        variables: {
          teamAlias,
        },
      }
    },
  }, {
    resource: "adminDatasets",
    url: ({ role, account }) => role === "admin" ? `/api/${account}/datasets` : null,
  }],
  mapStateToProps: (state, props) => ({
    teamId: getTeamId(state, props),
    teamRole: getTeamRole(state, props),
    datasets: getDatasets(state, props),
    entitlements: getEntitlements(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
